/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { instancesGetBySlug } from "../funcs/instancesGetBySlug.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { GetInstanceResult } from "../models/components/getinstanceresult.js";
import {
  GetInstanceRequest,
  GetInstanceSecurity,
} from "../models/operations/getinstance.js";
import { unwrapAsync } from "../types/fp.js";

export class Instances extends ClientSDK {
  /**
   * getInstance instances
   *
   * @remarks
   * Load all relevant data for an instance of a toolset and environment
   */
  async getBySlug(
    request: GetInstanceRequest,
    security?: GetInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetInstanceResult> {
    return unwrapAsync(instancesGetBySlug(
      this,
      request,
      security,
      options,
    ));
  }
}
